import React, { FC, useMemo } from 'react';

import { AppFieldBox } from 'components/appComponents';
import { DateRangeBox, SelectBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

type Props = {
  onChangeDateBegin: (value: string | Date | number) => void;
  onChangeDateEnd: (value: string | Date | number) => void;
  onChangeTarsport: (value: number) => void;
  onChangeTarsportName: (name: string) => void;
  dateBegin: string;
  dateEnd: string;
  transport: number | null;
};

const DateRangePicker: FC<Props> = ({
  dateBegin,
  dateEnd,
  transport,
  onChangeDateBegin,
  onChangeDateEnd,
  onChangeTarsport,
  onChangeTarsportName,
}) => {
  const storeTransport: any = useMemo(() => {
    const defaultFilter = ['transportType', '=', '2'];
    return $createDataSource('/v1/Transport', 'id', { defaultFilter });
  }, []);

  const handleChangeDate = (dateRange: Array<string | Date | number>) => {
    dateRange[0] && onChangeDateBegin(dateRange[0]);
    dateRange[1] && onChangeDateEnd(dateRange[1]);
  };

  return (
    <div className="d-flex align-end pt-2">
      <div className="pr-2">
        <AppFieldBox label="Транспорт" labelTop className="align-end" styles={{ margin: 0 }}>
          <SelectBox
            stylingMode="underlined"
            placeholder="Выберите транспорт"
            mode="text"
            value={transport}
            onValueChange={onChangeTarsport}
            onOptionChanged={(e) => {
              if (e.name === 'selectedItem' && e.value?.id) {
                onChangeTarsportName(e.value.fullName);
              }
            }}
            searchMode="contains"
            searchExpr="fullName"
            searchEnabled
            displayExpr="fullName"
            valueExpr="id"
            dataSource={storeTransport}
          />
        </AppFieldBox>
      </div>
      <DateRangeBox
        value={[dateBegin, dateEnd]}
        onValueChanged={(e) => handleChangeDate(e.value)}
        dateSerializationFormat="yyyy-MM-dd"
        stylingMode="underlined"
        useMaskBehavior
      />
    </div>
  );
};

export default DateRangePicker;
